import PropTypes from 'prop-types';
import {
    Tabs,
    Tab,
    Typography,
    Box,
    IconButton,
    Checkbox
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Page_Padding } from '../../constants';

const TabForPricing = ({
    tabs,
    value,
    onChange,
}) => {
    // ;
    // const handleNextTab = () => {
    //     const nextIndex = (value + 1) % tabs.length;
    //     onChange(null, nextIndex);
    // };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 5 }}>
            <Tabs
                value={value}
                onChange={onChange}
                indicatorColor="transparent"
                variant={"scrollable"}
                scrollButtons={"auto"}
                sx={{
                    "& .MuiTabs-flexContainer": {
                        flexWrap: "nowrap",
                    },
                    flexGrow: 1,
                    overflowX: "auto",
                }}
            >
                {tabs?.map((item, index) => (
                    <Tab
                        key={index}
                        sx={{
                            background: value === index ? '#FFF6F6' : '#F7F7F7',
                            border: value === index ? '1px solid #DC143C' : '1px solid #CCCCCCCC',
                            padding: 0,
                            px:2,
                            mx: 2,
                            borderRadius:"5px",
                    minHeight:"35px"

                        }}
                        label={
                            <Typography
                                variant='body2'
                                sx={{
                                    textTransform: "capitalize",
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {item.label}

                            </Typography>
                        }
                    />
                ))}
            </Tabs>
            {/* <IconButton
                sx={{
                    p: 1, mr: 2,
                    bgcolor: "#FFEAEA",
                    '&:hover': {
                        bgcolor: "#FFEAEA",
                    }
                }}
                onClick={handleNextTab}
            >
                <ArrowForwardIosIcon sx={{ fontSize: "20px", color: "red.main" }} />
            </IconButton> */}

        </Box>
    );
};

TabForPricing.propTypes = {
    tabs: PropTypes.array.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,

};

export default TabForPricing;
